//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import RFCheckboxField from '../../../components/ReduxFormComps/RFCheckboxField';
import renderTextField from '../../../components/MaterialUi/renderTextField';
import styles from './styles'
import { checkboxCustomStyle,checkboxCustomLabelStyle } from '../../ProjectApollo/CheckboxUtil';
import type { ContainerRowReduxReadonlyTextAndOverrideField$Props } from '../flowTypes'

const checkboxOnChange=(e,props)=>{
    if (!e.target.checked){
        if (props.notOverrideFunc){
            const notOverrideFunc = props.notOverrideFunc
            const parentProps = (props.parentProps:any)
            notOverrideFunc(parentProps)
        }
    }
}

const ContainerRowReduxReadonlyTextAndOverrideField=(props:ContainerRowReduxReadonlyTextAndOverrideField$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                <Field
                    name={props.textField}
                    component={renderTextField}
                    label={props.textLabel}
                    style={styles.textFieldStyle}
                    type={props.textType?props.textType:'string'}
                    disabled={!props.isOverride}
                />
                <Field name={props.checkboxField} 
                    component={RFCheckboxField} 
                    label={props.checkboxLabel}
                    customStyle={checkboxCustomStyle}
                    customLabelStyle={checkboxCustomLabelStyle(props.isOverride)}
                    onChange={(e)=>checkboxOnChange(e,props)}
                />
            </div>
        </div>
    )
}

export default ContainerRowReduxReadonlyTextAndOverrideField


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/ContainerRowReduxReadonlyTextAndOverrideField.js